import ConfigCollaborateur from '../configCollaborateur.model'

export default {
  add: ({ POST }, configCollaborateur) =>
    new Promise((resolve, reject) => {
      if (!(configCollaborateur instanceof ConfigCollaborateur)) {
        return reject(
          new Error(
            `Erreur paramètre : ConfigCollaborateur attendu mais reçu "${configCollaborateur.constructor.name}"`
          )
        )
      }
      return POST(`production/configCollaborateurs`, configCollaborateur)
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200 && data.id) {
            const configCollaborateur = new ConfigCollaborateur(data)
            resolve(configCollaborateur)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
}
